<cwc-page>

    <app-topbar slot="header"></app-topbar>
    <app-sidebar slot="sidenav"></app-sidebar>

    <div slot="main" id="content-page">
        <router-outlet></router-outlet> <!-- ✅ Aquí sí va -->
    </div>

</cwc-page>